import React, { JSX, ReactNode } from 'react';
import { styled } from '@mui/material';
import Container from './Container';

type ListProps = {
  title: string,
  tools?: JSX.Element,
  children: ReactNode
};

const ListContainer = styled(Container)(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.grey[500]}`,
}));

export default ({
  title,
  tools,
  children
}: ListProps) => {
  return <ListContainer>

    <Container text-align='center'>
      <h4>{title}</h4>
    </Container>

    {!!tools && (
      <Container margin-h="medium">{tools}</Container>
    )}

    {children}
  </ListContainer>
};